 
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  GraphQLDateString: { input: string; output: string; }
  GraphQLObjectId: { input: string; output: string; }
  JSON: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
};

export type WireCronSchedule = {
  __typename?: 'CronSchedule';
  day: Scalars['String']['output'];
  /** 0-6 for Sunday-Saturday */
  dayOfTheWeek: Scalars['String']['output'];
  hour: Scalars['String']['output'];
  minute: Scalars['String']['output'];
  month: Scalars['String']['output'];
};

export type WireCronScheduleInput = {
  day: Scalars['String']['input'];
  dayOfTheWeek: Scalars['String']['input'];
  hour: Scalars['String']['input'];
  minute: Scalars['String']['input'];
  month: Scalars['String']['input'];
};

export type WireJobDefinition = {
  __typename?: 'JobDefinition';
  _id: Scalars['GraphQLObjectId']['output'];
  args: Scalars['JSON']['output'];
  clientIds: Array<Scalars['GraphQLObjectId']['output']>;
  clients: Array<WireNameAndId>;
  createTimestamp: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  jobUser: WireNameAndId;
  jobUserId: Scalars['GraphQLObjectId']['output'];
  name: Scalars['String']['output'];
  nextExecutionTime?: Maybe<Scalars['Timestamp']['output']>;
  runs: Array<WireJobRun>;
  schedule: WireCronSchedule;
  timezone: TimezoneEnum;
  type: JobTypeEnum;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId: Scalars['GraphQLObjectId']['output'];
  updateUserInfo: WireNameAndId;
  url: Scalars['String']['output'];
  versions?: Maybe<Scalars['JSON']['output']>;
};


export type WireJobDefinitionRunsArgs = {
  nbr?: InputMaybe<Scalars['Int']['input']>;
};

export type WireJobDefinitionFilterInput = {
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusIn?: InputMaybe<Array<JobTypeEnum>>;
};

export type WireJobDefinitionInput = {
  /** if _id is omitted, a Job will be created */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  args: Scalars['JSON']['input'];
  clientIds: Array<Scalars['GraphQLObjectId']['input']>;
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  jobUserId: Scalars['GraphQLObjectId']['input'];
  name: Scalars['String']['input'];
  schedule: WireCronScheduleInput;
  timezone: TimezoneEnum;
  type: JobTypeEnum;
  url: Scalars['String']['input'];
};

export enum JobResultEnum {
  Enqueued = 'Enqueued',
  Failure = 'Failure',
  Processing = 'Processing',
  Running = 'Running',
  Succeeded = 'Succeeded'
}

export type WireJobRun = {
  __typename?: 'JobRun';
  _id: Scalars['GraphQLObjectId']['output'];
  endExecutionTime?: Maybe<Scalars['Timestamp']['output']>;
  jobDefinitionId: Scalars['GraphQLObjectId']['output'];
  log?: Maybe<Scalars['JSON']['output']>;
  logId: Scalars['String']['output'];
  logUrl: Scalars['String']['output'];
  startExecutionTime?: Maybe<Scalars['Timestamp']['output']>;
  startStatusCode: Scalars['String']['output'];
  status?: Maybe<JobResultEnum>;
};

export type WireJobRunFilterInput = {
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};

export enum JobStatusEnum {
  Active = 'Active',
  Completed = 'Completed',
  Delayed = 'Delayed',
  Failed = 'Failed',
  Paused = 'Paused',
  Waiting = 'Waiting'
}

export enum JobTypeEnum {
  Deleted = 'Deleted',
  Manual = 'Manual',
  Scheduled = 'Scheduled'
}

export type WireMutation = {
  __typename?: 'Mutation';
  defaultMutation?: Maybe<Scalars['String']['output']>;
  executeJob: WireJobRun;
  upsertJobDefinitions: Array<WireJobDefinition>;
};


export type WireMutationExecuteJobArgs = {
  args?: InputMaybe<Scalars['JSON']['input']>;
  jobId: Scalars['GraphQLObjectId']['input'];
};


export type WireMutationUpsertJobDefinitionsArgs = {
  input: Array<WireJobDefinitionInput>;
};

export type WireNameAndId = {
  __typename?: 'NameAndId';
  _id: Scalars['GraphQLObjectId']['output'];
  name: Scalars['String']['output'];
};

export type WireQuery = {
  __typename?: 'Query';
  defaultQuery?: Maybe<Scalars['String']['output']>;
  jobDefinitions: Array<WireJobDefinition>;
  jobRuns: Array<WireJobRun>;
};


export type WireQueryJobDefinitionsArgs = {
  filter?: InputMaybe<WireJobDefinitionFilterInput>;
};


export type WireQueryJobRunsArgs = {
  filter: WireJobRunFilterInput;
};

export enum TimezoneEnum {
  AmericaChicago = 'AmericaChicago',
  AmericaNew_York = 'AmericaNew_York',
  AsiaHong_Kong = 'AsiaHong_Kong',
  AsiaTokyo = 'AsiaTokyo',
  EuropeAmsterdam = 'EuropeAmsterdam',
  EuropeBerlin = 'EuropeBerlin',
  EuropeBrussels = 'EuropeBrussels',
  EuropeCopenhagen = 'EuropeCopenhagen',
  EuropeHelsinki = 'EuropeHelsinki',
  EuropeLondon = 'EuropeLondon',
  EuropeLuxembourg = 'EuropeLuxembourg',
  EuropeOslo = 'EuropeOslo',
  EuropeParis = 'EuropeParis',
  EuropeStockholm = 'EuropeStockholm',
  EuropeZurich = 'EuropeZurich'
}
